export async function store (task, { assignees, team_id, label_id }) {
  return await axios.post('/tasks', {
    ...task,
    assignees,
    team_id,
    label_id,
  });
}

export async function update (task, updatedFields) {
  return await axios.put(`/tasks/${task.id}`, {
    ...updatedFields,
  });
}

export async function destroy (task) {
  return await axios.delete(`/tasks/${task.id}`);
}

export async function updateSubtask (subtask, updatedFields) {
  return await axios.put(`/tasks/${subtask.task_id}/subtasks/${subtask.id}`, {
    ...updatedFields,
  });
}

export async function pickupTask (task) {
  return await axios.post(`/tasks/${task.id}/pick-up`);
}

export async function approveTask (taskId) {
  return await axios.post(`/tasks/${taskId}/approve`);
}

export async function rejectTask (taskId) {
  return await axios.post(`/tasks/${taskId}/reject`);
}
